import 'apps/hiring/styles/components/applicant/target-content.scss';
import React from 'react';
import PropTypes from 'prop-types';
import Collapsable from 'library/components/collapsable';
import EscapedTag from 'library/components/escaped-tag';
import { resolve } from 'library/helpers/path-resolver';
import TabbedCarousel from 'library/components/tabbed-carousel';

const LMMContent = ({ development, label, content_range, score, focus, setFocus=()=>{}, dataParse=v=>v, dataKey='insight', ...props }) => {

  const active = development===focus;

  return (
    <div className={['less-moderate-more-content', active?'active':null].filter(c=>c).join(' ')}>
      <span onClick={()=>setFocus(development)}>{label||development}</span>
      <Collapsable
        component="div"
        className="less-moderate-more-content-inner"
        data-start={resolve(content_range, 'start', 0)}
        data-end={resolve(content_range, 'end', 0)}
        data-score={score}
        collapsed={!active}
      >
        <EscapedTag>{dataParse(props[dataKey])}</EscapedTag>
      </Collapsable>
    </div>
  );
};

LMMContent.propTypes = {
  development: PropTypes.string,
  label: PropTypes.string,
  content_range: PropTypes.object,
  score: PropTypes.number,
  focus: PropTypes.string,
  setFocus: PropTypes.func,
  dataParse: PropTypes.func,
  dataKey: PropTypes.string
};

const LMM = ({ options=[], focus=null, score=0, setFocus, ...props }) => {
  return (
    <div className="less-moderate-more-container">
      <LMMContent setFocus={setFocus} label={'Less'} {...(options.find(o=>o.development==='low')||{})} score={score} focus={focus} {...props} />
      <LMMContent setFocus={setFocus} label={'Moderate'} {...(options.find(o=>o.development==='medium')||{})} score={score} focus={focus} {...props} />
      <LMMContent setFocus={setFocus} label={'More'} {...(options.find(o=>o.development==='high')||{})} score={score} focus={focus} {...props} />
    </div>
  );
};

LMM.propTypes = {
  options: PropTypes.array,
  focus: PropTypes.string,
  score: PropTypes.number,
  setFocus: PropTypes.func
};

class TargetContent extends React.Component {
  static propTypes = {
    content: PropTypes.object,
    score: PropTypes.number,
    focus: PropTypes.string,
    setFocus: PropTypes.func,
    description: PropTypes.string
  }

  parseQuestions = (q) => (
    q?`<ul>${q.map(_q=>`<li>${_q}</li>`).join('')}</ul>`:''
  );

  render() {
    const {
      content,
      description,
      score,
      focus,
      setFocus=()=>{}
    } = this.props;

    return (
      <div className="hiring-application-target-content-inner">
        <TabbedCarousel defaultIndex={0} tabs={['Definition', 'Insights', 'Tips', 'Interview Questions']}>
          <EscapedTag className="hiring-application-target-content-description">{String(description)}</EscapedTag>
          <LMM setFocus={setFocus} focus={focus} options={resolve(content, 'insights', []).filter(c=>c)} dataKey={'insight'} score={Number(score)} />
          <LMM setFocus={setFocus} focus={focus} options={resolve(content, 'tips', []).filter(c=>c)} dataKey={'insight'} score={Number(score)} />
          <LMM setFocus={setFocus} focus={focus} options={resolve(content, 'questions', []).filter(c=>c)} dataKey={'questions'} dataParse={this.parseQuestions} score={Number(score)} />
        </TabbedCarousel>
      </div>
    );
  }
}

export default TargetContent;
